import { Attributes, LookupBase } from '@singularsystems/neo-core';
import { PaymentType } from '../PaymentType';

export default class PaymentExportLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public paymentExportId: number = 0;

    @Attributes.Date()
    public readonly paymentDate: Date = new Date();

    public entityId: number = 0;

    public paymentType: PaymentType | null = null;

    @Attributes.Float()
    public paymentAmount: number = 0;

    public isExported: boolean = false;

    public fromAccountNumber: string = "";

    public readonly previouslyCreated: boolean = false;

    @Attributes.Integer()
    public readonly unlinkedRecordCount: number = 0;

    @Attributes.Integer()
    public readonly unProcessedCount: number = 0;

    // Client only properties / methods
}